import { authenticatedAxios } from './axios';
import getBestAvailableVehicleImageQuery, {
  type BestAvailableVehicleImageInput,
  type BestAvailableVehicleImageResponse
} from './GraphQL/queries/getBestAvailableVehicleImage';

const endpoint = `${process.env.CARVANA_APP_BFF_API}/graphql/`;

const VehicleBffApi = {
  getBestAvailableImage: async (input: BestAvailableVehicleImageInput, signal?: AbortSignal) => {
    const response = await authenticatedAxios.post<BestAvailableVehicleImageResponse>(endpoint, {
      query: getBestAvailableVehicleImageQuery,
      variables: { input },
      signal
    });
    response?.data?.errors?.forEach(error => {
      throw error;
    });
    return response.data.data;
  }
};

export default VehicleBffApi;
